import React, { FunctionComponent, memo } from 'react'

import { useAppSelector } from '../../../redux/hooks'
import { CadastralImportBox } from '../CadastralImportBox/CadastralImportBox'
import { PropertyDetailLastNote } from '../PropertyDetailLastNote/PropertyDetailLastNote'
import { PropertyDetailOwnershipRights } from '../PropertyDetailOwnershipRights/PropertyDetailOwnershipRights'
import { PropertyDetailSidebarLv } from '../PropertyDetailSidebarLv/PropertyDetailSidebarLv'
import { PropertyDetailSidebarOwnershipRestriction } from '../PropertyDetailSidebarOwnershipRestriction/PropertyDetailSidebarOwnershipRestriction'
import { PropertyDetailSidebarPrice } from '../PropertyDetailSidebarPrice/PropertyDetailSidebarPrice'
import { PropertyDetailSidebarRuian } from '../PropertyDetailSidebarRuian/PropertyDetailSidebarRuian'

export interface DetailDrawerPropertyContentProps {
  propertyId: string
}

export const DetailDrawerPropertyContent: FunctionComponent<DetailDrawerPropertyContentProps> =
  memo(props => {
    const noData = useAppSelector(
      state => !state.property.drm.data?.id && !state.property.crm.data
    )

    return (
      <div className="flex flex-col space-y-8 mb-4">
        <PropertyDetailSidebarOwnershipRestriction
          propertyId={props.propertyId}
          isDrawer
        />
        <PropertyDetailLastNote isDrawer />
        {noData && (
          <CadastralImportBox className="mt-2" entityType="property" />
        )}
        <PropertyDetailSidebarLv isDrawer />
        <PropertyDetailSidebarPrice isDrawer />
        <PropertyDetailSidebarRuian isDrawer />
        <PropertyDetailOwnershipRights isDrawer />
      </div>
    )
  })
